import {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Translate} from 'react-redux-i18n';
import * as snackbarsActions from '../../actions/snackbars';
import projectService from '../../services/project/ProjectService';
import ProjectDescriptionForm from '../../components/project/ProjectDescriptionForm';
import {captureError} from '../../utils/log';

export class ProjectEditView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false
    };

    this.handleEditProject = this.handleEditProject.bind(this);
  }

  handleEditProject(projectUpdated) {
    if (this.state.submitted) {
      return;
    }

    this.setState({submitted: true});

    const mergedProjectUpdates = {...this.props.project, ...projectUpdated};

    projectService.updateProject(mergedProjectUpdates, mergedProjectUpdates.projectId)
      .then(() => {
        this.props.actions.addSuccess(<Translate
          value="project.edit.editProjectDescriptionSuccess"
          name={projectUpdated.name}
        />);
        this.props.onClose();
      })
      .catch(error => {
        this.props.actions.addError(<Translate value="error.generic"/>);
        captureError('[ProjectEditView](handleEditProject) projectService.updateProject', error);
      })
      .finally(() => {
        this.setState({submitted: false});
      });
  }

  render() {
    return (
      <ProjectDescriptionForm
        title={<h2><Translate value="project.edit.editProjectDescription"/></h2>}
        project={this.props.project}
        onCancel={this.props.onClose}
        onValidate={this.handleEditProject}
        submitted={this.state.submitted}
        disabledCountrySelector
        isFromProjectEditView
        oldestInterventionDateSet={this.props.oldestInterventionDateSet}
      />
    );
  }
}

ProjectEditView.propTypes = {
  project: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  oldestInterventionDateSet: PropTypes.string
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectEditView);
